// extracted by mini-css-extract-plugin
export default {"card":"jobCard_card__F4dVU","iconContainer":"jobCard_iconContainer__DRRzN","textContainer":"jobCard_textContainer__LsdYu"};